import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Pie, Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from "chart.js";
import "../styles/CourseReportModal.css";

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const HtmlToPdfExport = ({ participantId, courseId, courseName, participantName }) => {
    const [data, setData] = useState([]);
    const [reportStats, setReportStats] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/learning/question-report/55/2`)
            .then((res) => res.json())
            .then(setData)
            .catch(console.error);

        fetch(`${process.env.REACT_APP_API_URL}/learning/history/55/2`)
            .then((res) => res.json())
            .then((arr) => setReportStats(arr[arr.length - 1]))
            .catch(console.error);
    }, [participantId, courseId]);

    const exportToPdf = () => {
        const input = document.getElementById("printable-area");
        if (!input) return;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            let position = 10;
            let pageHeight = pdf.internal.pageSize.getHeight();

            if (pdfHeight < pageHeight) {
                pdf.addImage(imgData, "PNG", 10, position, pdfWidth - 20, pdfHeight);
            } else {
                const canvasHeight = canvas.height;
                const canvasWidth = canvas.width;
                const ratio = canvasWidth / (pdfWidth - 20);
                const pageHeightPx = ratio * (pageHeight - 20);

                let remainingHeight = canvasHeight;
                let yOffset = 0;

                while (remainingHeight > 0) {
                    const pageCanvas = document.createElement("canvas");
                    pageCanvas.width = canvasWidth;
                    pageCanvas.height = Math.min(pageHeightPx, remainingHeight);
                    const ctx = pageCanvas.getContext("2d");
                    ctx.drawImage(
                        canvas,
                        0,
                        yOffset,
                        canvasWidth,
                        pageCanvas.height,
                        0,
                        0,
                        canvasWidth,
                        pageCanvas.height
                    );

                    const img = pageCanvas.toDataURL("image/png");
                    pdf.addImage(img, "PNG", 10, 10, pdfWidth - 20, (pageCanvas.height * (pdfWidth - 20)) / canvasWidth);

                    remainingHeight -= pageCanvas.height;
                    yOffset += pageCanvas.height;

                    if (remainingHeight > 0) pdf.addPage();
                }
            }

            const timestamp = new Date().toLocaleString();
            const pageCount = pdf.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdf.setPage(i);
                pdf.setFontSize(10);
                pdf.text(`Tarih: ${timestamp}`, 14, 10);
                pdf.text(`Sayfa ${i} / ${pageCount}`, pdf.internal.pageSize.getWidth() - 40, pdf.internal.pageSize.getHeight() - 10);
            }

            pdf.save("Ogrenci_Gelisim_Raporu.pdf");
        });
    };

    const isCorrect = (given, correct) =>
        given?.trim().toLowerCase() === correct?.trim().toLowerCase();

    const stats = {
        total: data.length,
        preCorrect: data.filter(q => isCorrect(q.preAnswer, q.correctAnswer)).length,
        postCorrect: data.filter(q => isCorrect(q.postAnswer, q.correctAnswer)).length,
    };

    const pieData = {
        labels: ["Öğrenilen", "Öğrenilemeyen", "Zaten Bilinen", "Bilgi Kaybı"],
        datasets: [
            {
                data: [
                    reportStats?.learned || 0,
                    reportStats?.notLearned || 0,
                    reportStats?.alreadyKnew || 0,
                    reportStats?.lostKnowledge || 0
                ],
                backgroundColor: ["#34d399", "#f87171", "#60a5fa", "#fbbf24"],
                borderWidth: 1
            }
        ]
    };

 const barData = {
     labels: ["Ön Test", "Son Test"],
     datasets: [
         {
             label: "Doğru Sayısı",
             data: [stats.preCorrect, stats.postCorrect],
             backgroundColor: ["#60a5fa", "#34d399"]
         }
     ]
 };

    return (
        <div>
            <div id="printable-area" className="report-container">
                <img src="/logomedu.svg" alt="MeduVR Logo" className="report-logo" />
                <h2 className="report-title">{courseName}</h2>
                <h2 className="report-title">Öğrenci Soru Bazlı Gelişim Raporu</h2>

                <div className="report-stats-box">
                    <p className="participant-name"><strong>Katılımcı:</strong> {participantName}</p>
                    <p><strong>Toplam Soru Sayısı:</strong> {stats.total}</p>
                    <p><strong>Ön Test Doğru Sayısı:</strong> {stats.preCorrect}</p>
                    <p><strong>Son Test Doğru Sayısı:</strong> {stats.postCorrect}</p>
                </div>
                <div className={"report-charts-container"}>
                    <h4 className="chart-title">ÖĞRENME İSTATİSTİKLERİ</h4>
                    <div className="report-visuals">

                        <div className="report-summary-box">
                            {reportStats && (
                                <>
                                    <p><strong>Öğrenilen:</strong> {reportStats.learned}</p>
                                    <p><strong>Öğrenilmeyen:</strong> {reportStats.notLearned}</p>
                                    <p><strong>Zaten Bilinen:</strong> {reportStats.alreadyKnew}</p>
                                    <p><strong>Unutulmuş Bilgi:</strong> {reportStats.lostKnowledge}</p>
                                    <p><strong>Gelişim Oranı:</strong> %{(reportStats.learningRate * 100).toFixed(2)}
                                    </p>
                                    <div className="progress-bar-wrapper">
                                        <div className="progress-bar-outer">
                                            <div
                                                className="progress-bar-inner"
                                                style={{width: `${reportStats.learningRate * 100}%`}}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="report-chart-box">
                            <h4 className="chart-title">Öğrenme Dağılımı</h4>
                            <Pie data={pieData}/>
                        </div>
                    </div>

                </div>

                <div className="report-bar-chart">
                    <h4 className="chart-title">Ön/Son Test Doğru Sayısı Karşılaştırması</h4>
                    <Bar data={barData} options={{
                        plugins: {
                            legend: {
                                display: false
                            }
                        }

                    }}/>
                </div>

                <table className="comparison-table">
                    <thead>
                    <tr>
                        <th>Soru</th>
                        <th>Doğru Cevap</th>
                        <th>Kurstan Önce</th>
                        <th>Kurstan Sonra</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data.map((row, i) => (
                        <tr key={i}>
                            <td className="question-cell">{row.question}</td>
                            <td className="answer-cell">{row.correctAnswer}</td>
                            <td className={isCorrect(row.preAnswer, row.correctAnswer) ? "cell-correct" : "cell-wrong"}>{row.preAnswer || "-"}</td>
                            <td className={isCorrect(row.postAnswer, row.correctAnswer) ? "cell-correct" : "cell-wrong"}>{row.postAnswer || "-"}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>

            <div className="pdf-button-container">
                <button onClick={exportToPdf} className="pdf-export-button">
                    PDF Olarak Kaydet
                </button>
            </div>
        </div>
    );
};

export default HtmlToPdfExport;
